// Date utility functions for converting UTC to IST and formatting dates

// Convert UTC date string to IST and format as date string
export const formatDateToIST = (dateString) => {
  if (!dateString) return 'Not available';
  
  try {
    const date = new Date(dateString);
    // Add 5 hours and 30 minutes to convert UTC to IST
    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date';
  }
};

// Convert UTC date string to IST and format as date and time string
export const formatDateTimeToIST = (dateString) => {
  if (!dateString) return 'Not available';
  
  try {
    const date = new Date(dateString);
    // Add 5 hours and 30 minutes to convert UTC to IST
    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } catch (error) {
    console.error('Error formatting date time:', error);
    return 'Invalid date';
  }
};

// Convert UTC date string to IST and format as time only
export const formatTimeToIST = (dateString) => {
  if (!dateString) return 'Not available';
  
  try {
    const date = new Date(dateString);
    // Add 5 hours and 30 minutes to convert UTC to IST
    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Kolkata'
    });
  } catch (error) {
    console.error('Error formatting time:', error);
    return 'Invalid time';
  }
};

// Convert UTC date string to IST and format as short date string
export const formatShortDateToIST = (dateString) => {
  if (!dateString) return 'Not available';
  
  try {
    const date = new Date(dateString);
    // Add 5 hours and 30 minutes to convert UTC to IST
    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  } catch (error) {
    console.error('Error formatting short date:', error);
    return 'Invalid date';
  }
};

// Get current date in IST for form inputs (YYYY-MM-DD format)
export const getCurrentDateIST = () => {
  const now = new Date();
  const istDate = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  return istDate.toISOString().split('T')[0];
};

// Check if a date is in the past (for overdue checks)
export const isDateInPast = (dateString) => {
  if (!dateString) return false;
  
  try {
    const date = new Date(dateString);
    const now = new Date();
    return date < now;
  } catch (error) {
    console.error('Error checking date:', error);
    return false;
  }
}; 

/**
 * Format number to Indian numbering system (INR convention)
 * e.g., 1234567 becomes 12,34,567
 */
export const formatIndianNumber = (number) => {
  if (number === null || number === undefined || isNaN(number)) {
    return '0';
  }
  
  const num = parseFloat(number);
  if (num === 0) return '0';
  
  // Convert to string and split by decimal point
  const parts = num.toString().split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1] || '';
  
  // Add commas for Indian numbering system
  let formattedInteger = '';
  const len = integerPart.length;
  
  for (let i = 0; i < len; i++) {
    if (i > 0 && (len - i) % 2 === 1 && i !== len - 1) {
      formattedInteger += ',';
    }
    formattedInteger += integerPart[i];
  }
  
  // Add decimal part if it exists
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};

/**
 * Format currency amount in Indian Rupees
 * e.g., 1234567 becomes ₹12,34,567
 */
export const formatIndianCurrency = (amount) => {
  const formatted = formatIndianNumber(amount);
  return `₹${formatted}`;
}; 